export default "__VITE_ASSET__ceNJOH_J__"